import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 本番環境のドメインを指定
const PRODUCTION_DOMAIN = 'webarstudio.konamotsu.com';

// 現在のドメインに基づいて環境を判定
const isProduction = window.location.hostname === PRODUCTION_DOMAIN;

const firebaseConfig = {
  apiKey: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_API_KEY 
    : process.env.REACT_APP_DEV_FIREBASE_API_KEY,
  authDomain: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_AUTH_DOMAIN 
    : process.env.REACT_APP_DEV_FIREBASE_AUTH_DOMAIN,
  projectId: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_PROJECT_ID 
    : process.env.REACT_APP_DEV_FIREBASE_PROJECT_ID,
  storageBucket: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_STORAGE_BUCKET 
    : process.env.REACT_APP_DEV_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_MESSAGE_SENDER_ID 
    : process.env.REACT_APP_DEV_FIREBASE_MESSAGE_SENDER_ID,
  appId: isProduction 
    ? process.env.REACT_APP_PROD_FIREBASE_APP_ID 
    : process.env.REACT_APP_DEV_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

export const storage = getStorage(firebaseApp);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
